/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterEvents } from '../types/FilterEvents'
import { defaultFormatTimeZone } from '../utils/consts'

interface EventsFiltersContextType {
  filters: FilterEvents
  setFilters: (filters: FilterEvents) => any
}
const initialState: EventsFiltersContextType = {
  filters: {
    pharmaciesIds: [],
    geoipStates: [],
    date: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-events-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const EventsFiltersContext = createContext(initialState)

const EventsFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <EventsFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </EventsFiltersContext.Provider>)
}

export default EventsFiltersContextProvider
